import CmsModelState from '../_util/cms-model';

class CMSLocationsState extends CmsModelState {
  get url() { return '/locations'; }
  get singular() { return 'location'; }
  get plural() { return 'locations'; }
}

export default CMSLocationsState;



// WEBPACK FOOTER //
// ./spa/state/cms/cms-locations.jsx